// extracted by mini-css-extract-plugin
export default {"TimerStyle":"common_TimerStyle__63Kb7"};